import { Language } from "@/types/__generated__/union-types"

export const convertLanguageToISOCode = (language: Language) => {
  switch (language) {
    case "ENGLISH":
      return "EN"
    case "GERMAN":
      return "DE"
    case "FRENCH":
      return "FR"
    case "ITALIAN":
      return "IT"
    default:
      throw new Error(`Unknown language: ${language}`)
  }
}

export const convertISOCodeToLanguage = (language: string | null | undefined): Language | undefined => {
  switch (language) {
    case "EN":
      return "ENGLISH"
    case "DE":
      return "GERMAN"
    case "FR":
      return "FRENCH"
    case "IT":
      return "ITALIAN"
    case undefined:
    case null:
      return undefined
  }
}
